import { Navigate, useLocation } from "react-router-dom";
import { useAccountStore } from "../common/account";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
    let isAuthenticated = useAccountStore(p => p.data?.accountData.accessToken != null);
    let location = useLocation();

    if (!isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}
